import React from 'react';
import { JcPage } from '../application/JcPage';
import { JcColumn, JcRow } from '../JcBox';
import { JcTitle } from '../JcTitle';
import { JcText } from '../JcText';
import { JcButton, JcButtonType } from '../button/JcButton';

export interface JcErrorViewProps {
    readonly title?: string;
    readonly message?: string;
    /** When provided, a primary "Try again" soft-recovers without a hard reload. */
    readonly onRetry?: () => void;
}

/**
 * Full-screen "something went wrong" panel shown when an error reaches a
 * {@link JcErrorBoundary}. When `onRetry` is given it leads with a soft retry;
 * otherwise (last-resort boundary) recovery is a hard reload / navigation so the
 * whole app re-initialises (auth re-runs, listeners re-subscribe) from a clean slate.
 */
export const JcErrorView = (props: JcErrorViewProps): React.ReactElement => {
    const title = props.title ?? 'Something went wrong';
    const message = props.message ?? 'We hit an unexpected error. Try again, reload the page, or head back home.';

    return (
        <JcPage className="jc-error-view" alignCenter justifyCenter>
            <JcColumn className="jc-error-view-panel" spacing alignCenter>
                <JcTitle title={title} />
                <JcText text={message} />
                <JcRow className="jc-error-view-actions" spacing>
                    {props.onRetry && (
                        <JcButton buttonType={JcButtonType.PRIMARY} onClick={props.onRetry}>
                            Try again
                        </JcButton>
                    )}
                    <JcButton
                        buttonType={props.onRetry ? JcButtonType.DEFAULT : JcButtonType.PRIMARY}
                        onClick={() => window.location.reload()}
                    >
                        Reload page
                    </JcButton>
                    <JcButton buttonType={JcButtonType.DEFAULT} onClick={() => window.location.assign('/')}>
                        Go home
                    </JcButton>
                </JcRow>
            </JcColumn>
        </JcPage>
    );
};
